import loadable from "@loadable/component";
export const ErrorPage = loadable(() => import("./Error"));
